var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "search-form row",
    staticStyle: {
      "margin": "10px 40px"
    },
    attrs: {
      "id": "sidebarSearchForm"
    }
  }, [_c('dynButton', {
    attrs: {
      "configs": {
        ID: 'buttons.expand-search',
        visible: true
      },
      "icon": _vm.angleIcon,
      "btnClasses": "btn-primary",
      "styleObj": {
        'position': 'absolute',
        'left': '60px',
        'top': '110px',
        'z-index': '999',
        'width': '28px',
        'height': '26px',
        'float': 'right'
      },
      "exec": _vm.showOtherFields
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "color": "rgb(69, 70, 72)",
      "position": "absolute",
      "top": "112px",
      "left": "100px"
    }
  }, [_vm._v(_vm._s(_vm.type == 'criteria' ? _vm.$Jed.firstUpperTranslate('search criteria') : _vm.$Jed.firstUpperTranslate('filter')))]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "expand"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expandSearch),
      expression: "expandSearch"
    }],
    staticClass: "searchfieldWrapper",
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "5px"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "25%"
    }
  }), _c('th', {
    staticStyle: {
      "width": "65%"
    }
  }), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  })]), _vm._v(" "), _vm._l((_vm.fields), function(f) {
    return _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (f.always || _vm.expandSearch),
        expression: "f.always || expandSearch"
      }]
    }, [(f.visible) ? _c('td', [_c('span', [_vm._v(_vm._s(f.label))])]) : _vm._e(), _vm._v(" "), (f.visible) ? _c('td', [((f.type == 'text' && f.field != 'mat') || f.field == 'mat') ? _c('input-w', [(f.type == 'text' && f.field != 'mat') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filtro[f.field]),
        expression: "filtro[f.field]"
      }],
      staticClass: "searchfield",
      attrs: {
        "type": "text",
        "id": 'formfield-' + f.field,
        "disabled": _vm.disableInput,
        "placeholder": f.placeholder
      },
      domProps: {
        "value": (_vm.filtro[f.field])
      },
      on: {
        "keydown": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
          $event.preventDefault();
          _vm.type == 'criteria' ? _vm.applyFilter() : _vm.showResults()
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filtro, f.field, $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (f.field == 'mat') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filtro[f.field]),
        expression: "filtro[f.field]"
      }],
      staticClass: "searchfield",
      attrs: {
        "id": "mat",
        "type": "text",
        "placeholder": f.placeholder,
        "disabled": _vm.macInserted
      },
      domProps: {
        "value": (_vm.filtro[f.field])
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.filtro, f.field, $event.target.value)
        }, function($event) {
          _vm.disableOthers()
        }]
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), (f.type == 'checkbox' && f.field == 'ricerca_in_matricola') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filtro[f.field]),
        expression: "filtro[f.field]"
      }],
      staticStyle: {
        "margin-left": "-140px",
        "height": "17px"
      },
      attrs: {
        "type": "checkbox",
        "id": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.filtro[f.field]) ? _vm._i(_vm.filtro[f.field], null) > -1 : (_vm.filtro[f.field])
      },
      on: {
        "input": function($event) {
          _vm.enableOthers()
        },
        "__c": function($event) {
          var $$a = _vm.filtro[f.field],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.filtro[f.field] = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.filtro[f.field] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.filtro, f.field, $$c)
          }
        }
      }
    }) : _vm._e(), _vm._v(" "), (f.type == 'checkbox' && f.field == 'considera_sostitutivi') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.filtro[f.field]),
        expression: "filtro[f.field]"
      }],
      staticStyle: {
        "margin-left": "-140px",
        "height": "17px"
      },
      attrs: {
        "type": "checkbox",
        "id": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.filtro[f.field]) ? _vm._i(_vm.filtro[f.field], null) > -1 : (_vm.filtro[f.field])
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.filtro[f.field],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.filtro[f.field] = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.filtro[f.field] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.filtro, f.field, $$c)
          }
        }
      }
    }) : _vm._e(), _vm._v(" "), (f.type == 'select') ? _c('v-select', {
      attrs: {
        "label": "type",
        "options": f.choices,
        "placeholder": f.placeholder,
        "selectStyle": {
          'background-color': 'white',
          height: '27px',
          'font-family': 'inherit'
        },
        "tagStyle": {
          'background-color': '#ccc',
          color: 'white',
          padding: '3px',
          height: '22px',
          margin: '2px 4px',
          'line-height': '15px'
        },
        "menuStyle": {
          position: 'relative',
          'max-height': '150px',
          top: '0px'
        },
        "activeStyle": {
          'background-color': '#ccc',
          color: 'white'
        },
        "highStyle": {
          'background-color': '#ccc',
          color: 'white'
        },
        "disabled": _vm.disableInput || _vm.disableSelectInput[f.field]
      },
      on: {
        "input": function($event) {
          _vm.onDropdownChange(_vm.filtro[f.field], f.field)
        }
      },
      model: {
        value: (_vm.filtro[f.field]),
        callback: function($$v) {
          _vm.$set(_vm.filtro, f.field, $$v)
        },
        expression: "filtro[f.field]"
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (f.delete_btn) ? _c('td', [_c('button', {
      staticClass: "btn btn-primary",
      staticStyle: {
        "padding": "2px 5px",
        "border-radius": "2px"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.emptyField(f.field)
        }
      }
    }, [_c('i', {
      class: _vm.$root.icons.clear,
      staticStyle: {
        "margin-left": "0px"
      },
      attrs: {
        "aria-hidden": "true"
      }
    })])]) : _vm._e()])
  })], 2), _vm._v(" "), _c('dynButton', {
    attrs: {
      "configs": {
        ID: 'buttons.search',
        visible: true
      },
      "icon": _vm.$root.icons.search_btn,
      "btnClasses": "btn-primary",
      "exec": _vm.type == 'criteria' ? _vm.applyFilter : _vm.showResults,
      "styleObj": {
        'z-index': '999',
        'width': '214px',
        'height': '26px',
        'margin-top': '7px'
      }
    }
  })], 1)])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c762a634","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu-components/SearchForm.vue
// module id = 1421
// module chunks = 1